import { render, staticRenderFns } from "./detail_virtual.vue?vue&type=template&id=089f0324&scoped=true"
import script from "./detail_virtual.vue?vue&type=script&lang=js"
export * from "./detail_virtual.vue?vue&type=script&lang=js"
import style0 from "./detail_virtual.vue?vue&type=style&index=0&id=089f0324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089f0324",
  null
  
)

export default component.exports